module.exports = __webpack_public_path__ + "static/media/ro.743a6875.png";